import { useEffect, useState } from "react";
import { api, fileUrl } from "../lib/api";
import { PageHeader } from "../components/Bits";
import { Calendar, Download, AlertTriangle, Search } from "lucide-react";

const CATS = ["All", "General", "Elections", "Rules", "Urgent"];

export default function Notices() {
  const [list, setList] = useState([]);
  const [cat, setCat] = useState("All");
  const [q, setQ] = useState("");

  useEffect(() => { api.get("/notices").then((r) => setList(r.data)); }, []);

  const filtered = list.filter((n) => {
    const mc = cat === "All" || n.category === cat || (cat === "Urgent" && n.is_urgent);
    const mq = !q || n.title.toLowerCase().includes(q.toLowerCase()) || (n.description || "").toLowerCase().includes(q.toLowerCase());
    return mc && mq;
  });

  return (
    <div data-testid="notices-page">
      <PageHeader title="Notices & Circulars" subtitle="Official announcements, roster updates and communications of the Association." />
      <section className="max-w-5xl mx-auto px-4 py-14">
        <div className="flex flex-wrap items-center justify-between gap-4 mb-8">
          <div className="flex flex-wrap gap-2">
            {CATS.map((c) => (
              <button key={c} onClick={() => setCat(c)}
                className={`px-4 py-1.5 rounded-full text-sm font-medium border transition-colors ${cat === c ? "bg-[#0B2E63] text-white border-[#0B2E63]" : "bg-white text-[#5A6270] border-[#E5DECF] hover:border-[#E6C687]"}`}
                data-testid={`notice-filter-${c.toLowerCase()}`}>{c}</button>
            ))}
          </div>
          <div className="relative">
            <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#8A6320]" />
            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search notices..."
              className="pl-9 pr-4 py-2 rounded-full border border-[#E5DECF] text-sm w-56 focus:outline-none focus:border-[#E6C687]" data-testid="notice-search" />
          </div>
        </div>

        <div className="space-y-4">
          {filtered.map((n) => (
            <div key={n.id} className="card-elite rounded-lg p-5 flex flex-col sm:flex-row sm:items-center gap-4" data-testid={`notice-${n.id}`}>
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1">
                  {n.is_urgent && <span className="inline-flex items-center gap-1 text-[11px] font-bold uppercase text-white bg-[#C53030] rounded px-2 py-0.5"><AlertTriangle size={11} /> Urgent</span>}
                  <span className="text-[11px] font-semibold uppercase tracking-wider text-[#92400E] bg-[#FEF3C7] rounded px-2 py-0.5">{n.category}</span>
                  <span className="text-xs text-[#5A6270] flex items-center gap-1"><Calendar size={12} /> {n.date}</span>
                </div>
                <h3 className="font-display text-lg font-semibold text-[#0B2E63]">{n.title}</h3>
                {n.description && <p className="text-sm text-[#5A6270] mt-1 leading-relaxed">{n.description}</p>}
              </div>
              {n.file_path && (
                <a href={fileUrl(n.file_path)} target="_blank" rel="noreferrer" className="btn-gold rounded-full px-4 py-2 text-sm font-semibold flex items-center gap-2 shrink-0" data-testid={`notice-download-${n.id}`}>
                  <Download size={15} /> View
                </a>
              )}
            </div>
          ))}
          {filtered.length === 0 && <p className="text-center text-[#5A6270] py-10">No notices found.</p>}
        </div>
      </section>
    </div>
  );
}
